export const common = {
  nav: {
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    services: 'Services',
    cases: 'Cases',
    contact: 'Contact',
    consultation: 'Free Consultation'
  },
  hero: {
    badge: 'JS Glass Corporation | Milgard & JELD-WEN Certified Dealer | 30 Years of Excellence',
    title1: 'Professional Glass &',
    title2: 'Window Solutions',
    subtitle: 'JS Glass Corporation - Milgard Windows & JELD-WEN Certified Dealer with 30 years of experience, providing custom glass fabrication, window installation and repair services',
    cta1: 'Free Consultation',
    cta2: 'View Products'
  },
  about: {
    badge: 'ABOUT US',
    title: 'About Us',
    subtitle: 'Established in 2000, JS Glass is a family owned windows and doors company',
    description: 'JS Glass sells high-quality windows and doors, as well as various glass provide such as wardrobe doors, bathroom shower doors, and glass itself. We do our best to find the high-quality products you need that are suitable for you. We offer highly competitive prices on similar products. Whether you are replacing your house\'s windows and doors or building a new structure, We are committed to provide the best possible total value package to our customers through quality and outstanding service in every thing that we do.',
    feature1Title: 'Family Owned Business',
    feature1Desc: 'Established in 2000, we have a knowledgeable sales team and installers with over 25 years of experience',
    feature2Title: 'Quality Products',
    feature2Desc: 'High-quality windows, doors, and glass products suitable for your needs',
    feature3Title: 'Competitive Pricing',
    feature3Desc: 'Highly competitive prices with the best possible total value package',
    stat1: 'Years of Service',
    stat2: 'Projects Completed',
    stat3: 'Customer Satisfaction'
  },
  products: {
    badge: 'PRODUCTS',
    title: 'Premium Window & Door Products',
    subtitle: 'Authorized dealer for Milgard and JELD-WEN, offering diverse window and door options to meet different needs and styles',
    viewDetails: 'View Details',
    product1: 'Vinyl Windows',
    product1Desc: 'Durable, energy-efficient, low-maintenance vinyl window series',
    product2: 'Aluminum Windows',
    product2Desc: 'Modern design, sturdy and durable aluminum windows',
    product3: 'Sliding Doors',
    product3Desc: 'Large glass design providing expansive views',
    product4: 'French Doors',
    product4Desc: 'Elegant design enhancing home aesthetics',
    product5: 'JS Glass Shower Doors',
    product5Desc: 'Custom JS Glass shower door systems with 30 years of craftsmanship excellence and various style options',
    product6: 'Wood Windows & Doors',
    product6Desc: 'JELD-WEN classic wood windows & doors with natural texture and superior sound insulation',
    product7: 'Fiberglass Entry Doors',
    product7Desc: 'JELD-WEN fiberglass entry doors, weather-resistant and beautifully crafted',
    product8: 'Commercial Glass',
    product8Desc: 'Commercial space glass solutions'
  },
  services: {
    badge: 'SERVICES',
    title: 'Comprehensive Service Solutions',
    subtitle: 'From consultation, measurement, design to installation, we provide one-stop professional services for a worry-free window upgrade experience',
    service1: 'Free Consultation',
    service1Desc: 'One-on-one professional consultation to provide the most suitable window solutions based on your needs',
    service2: 'On-site Measurement',
    service2Desc: 'Professional team provides free on-site precise measurements to ensure dimensions perfectly fit your space',
    service3: 'Design Solutions',
    service3Desc: 'Customized window design solutions with 3D preview, allowing you to see the installation effect in advance',
    service4: 'Professional Installation',
    service4Desc: 'Experienced installation team with 30 years of expertise strictly follows standard procedures to ensure installation quality',
    service5: 'Quality Warranty',
    service5Desc: 'Comprehensive after-sales warranty service for worry-free usage',
    ctaBadge: 'CONTACT US',
    ctaTitle1: 'Schedule Your',
    ctaTitle2: 'Free On-site',
    ctaTitle3: 'Measurement Now',
    ctaHeading1: 'Professional Team',
    ctaHeading2: 'At Your Service',
    ctaDesc: 'Our professional team has over 30 years of window installation experience. From initial consultation to final installation, we provide attentive service throughout. Schedule now to enjoy free on-site measurement service and let us create your ideal living space.',
    ctaButton: 'Schedule Now'
  },
  cases: {
    badge: 'CASE STUDIES',
    title: 'Success Stories',
    subtitle: 'View quality projects we completed for clients, witnessing professional quality and service',
    case1: 'Modern Residential Window Replacement',
    case1Desc: 'Full house Milgard vinyl window replacement, improving energy efficiency',
    case2: 'Commercial Building Glass Curtain Wall',
    case2Desc: 'Large commercial project glass curtain wall installation',
    case3: 'Luxury Villa Sliding Doors',
    case3Desc: 'Custom large sliding door system installation',
    case4: 'JS Glass Bathroom Shower Door Renovation',
    case4Desc: 'Modern style JS Glass shower door system upgrade with premium craftsmanship',
    case5: 'Office Glass Partitions',
    case5Desc: 'Commercial space glass partition design and installation',
    case6: 'Sunroom Construction',
    case6Desc: 'Custom sunroom glass structure project'
  },
  contact: {
    badge: 'CONTACT US',
    title: 'Contact Us',
    subtitle: 'Feel free to call or fill out the form, we will respond to your inquiry as soon as possible',
    formTitle: 'Send Message',
    formSubtitle: 'Fill out the form below and we will contact you soon',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    send: 'Send Message',
    sending: 'Sending...',
    success: 'Message sent successfully!',
    error: 'Failed to send, please try again later',
    infoTitle: 'Contact Information',
    address: 'Address',
    addressValue: '12211 Garvey Ave, El Monte, CA 91732',
    phoneValue: '(626) 443-2688',
    emailValue: 'info@jsglass.com',
    hours: 'Business Hours',
    hoursValue: 'Monday - Friday: 9:00 AM - 5:00 PM',
    hoursClosed: 'Closed on Weekends'
  },
  footer: {
    description: 'JS Glass Corporation is a Milgard Windows & JELD-WEN certified dealer with 30 years of experience, providing professional glass and window solutions.',
    quickLinks: 'Quick Links',
    services: 'Services',
    service1: 'Window Installation',
    service2: 'Glass Replacement',
    service3: 'JS Glass Shower Door Systems',
    service4: 'Commercial Glass',
    contact: 'Contact',
    rights: 'All rights reserved',
    poweredBy: 'Website Builder'
  },
  vinylWindows: {
    badge: 'PREMIUM VINYL WINDOWS',
    heroTitle: 'Milgard Vinyl Windows',
    heroSubtitle: 'Energy-efficient, low-maintenance vinyl windows designed for lasting beauty and performance',
    ctaButton: 'Get Free Quote',
    overviewTitle: 'Why Choose Vinyl Windows',
    overviewDesc: 'Milgard vinyl windows combine superior energy efficiency with timeless aesthetics. Engineered with advanced materials and precision craftsmanship, our vinyl windows deliver exceptional performance while requiring minimal maintenance.',
    feature1: 'Energy Efficient',
    feature1Desc: 'Advanced insulation technology reduces energy costs',
    feature2: 'Low Maintenance',
    feature2Desc: 'Never needs painting, easy to clean and maintain',
    feature3: 'Durable Construction',
    feature3Desc: 'Built to withstand harsh weather conditions',
    feature4: 'Lifetime Warranty',
    feature4Desc: 'Backed by industry-leading warranty coverage',
    stylesTitle: 'Available Window Styles',
    stylesSubtitle: 'Choose from a variety of styles to match your home\'s architecture',
    style1: 'Double Hung',
    style1Desc: 'Classic design with both sashes operable for easy cleaning',
    style2: 'Casement',
    style2Desc: 'Side-hinged windows that open outward for maximum ventilation',
    style3: 'Sliding',
    style3Desc: 'Smooth horizontal operation ideal for wide openings',
    style4: 'Picture',
    style4Desc: 'Fixed windows that maximize views and natural light',
    style5: 'Bay & Bow',
    style5Desc: 'Elegant projecting windows that add dimension to any room',
    style6: 'Awning',
    style6Desc: 'Top-hinged windows perfect for ventilation even in rain',
    galleryTitle: 'Vinyl Windows Gallery',
    gallerySubtitle: 'Explore our collection of premium Milgard vinyl windows installed in beautiful homes',
    benefitsTitle: 'Key Benefits',
    benefit1: 'Energy Savings',
    benefit1Desc: 'Multi-chamber design and Low-E glass reduce heating and cooling costs',
    benefit2: 'Noise Reduction',
    benefit2Desc: 'Superior insulation minimizes outside noise for a quieter home',
    benefit3: 'UV Protection',
    benefit3Desc: 'Blocks harmful UV rays to protect your furniture and flooring',
    benefit4: 'Cost Effective',
    benefit4Desc: 'Excellent value with long-term savings on maintenance and energy',
    benefit5: 'Design Flexibility',
    benefit5Desc: 'Available in multiple colors and finishes to match any décor',
    benefit6: 'Eco-Friendly',
    benefit6Desc: 'Recyclable materials and energy efficiency reduce environmental impact',
    glassTitle: 'Glass Options',
    glassSubtitle: 'Customize your windows with advanced glass technology',
    glass1: 'Low-E Glass',
    glass1Desc: 'Reflects heat while allowing natural light to pass through',
    glass2: 'Tempered Glass',
    glass2Desc: 'Enhanced safety glass that\'s 4-5 times stronger than standard glass',
    glass3: 'Laminated Glass',
    glass3Desc: 'Added security and sound insulation with interlayer protection',
    glass4: 'Obscure Glass',
    glass4Desc: 'Privacy glass options for bathrooms and other private spaces',
    warrantyTitle: 'Industry-Leading Warranty',
    warrantyDesc: 'Milgard vinyl windows are backed by a comprehensive lifetime warranty covering glass breakage, screen defects, and hardware. We stand behind our products with confidence, ensuring your investment is protected for years to come.',
    ctaTitle: 'Ready to Upgrade Your Windows?',
    ctaDesc: 'Contact us today for a free consultation and quote. Our experts will help you choose the perfect vinyl windows for your home.'
  },
  aluminumWindows: {
    badge: 'MODERN ALUMINUM WINDOWS',
    heroTitle: 'Milgard Aluminum Windows',
    heroSubtitle: 'Sleek, durable aluminum windows with contemporary design and superior strength',
    ctaButton: 'Get Free Quote',
    overviewTitle: 'Why Choose Aluminum Windows',
    overviewDesc: 'Milgard aluminum windows offer unmatched strength and modern aesthetics. With slim profiles and expansive glass areas, aluminum windows provide maximum natural light while maintaining structural integrity and energy efficiency.',
    feature1: 'Modern Design',
    feature1Desc: 'Sleek profiles and clean lines for contemporary architecture',
    feature2: 'Slim Frames',
    feature2Desc: 'Narrow frames maximize glass area and natural light',
    feature3: 'Superior Strength',
    feature3Desc: 'Aluminum construction provides exceptional durability',
    feature4: 'Lifetime Warranty',
    feature4Desc: 'Comprehensive warranty coverage for peace of mind',
    stylesTitle: 'Available Window Styles',
    stylesSubtitle: 'Modern aluminum window styles for every architectural need',
    style1: 'Sliding',
    style1Desc: 'Smooth horizontal operation with minimal maintenance',
    style2: 'Single Hung',
    style2Desc: 'Classic style with bottom sash operable',
    style3: 'Picture',
    style3Desc: 'Fixed windows for unobstructed views',
    style4: 'Casement',
    style4Desc: 'Side-hinged for excellent ventilation control',
    style5: 'Awning',
    style5Desc: 'Top-hinged design ideal for ventilation',
    style6: 'Architectural',
    style6Desc: 'Custom shapes and configurations for unique designs',
    galleryTitle: 'Aluminum Windows Gallery',
    gallerySubtitle: 'Discover our premium Milgard aluminum windows in modern homes',
    benefitsTitle: 'Key Benefits',
    benefit1: 'Exceptional Durability',
    benefit1Desc: 'Aluminum resists warping, cracking, and corrosion',
    benefit2: 'Maximum Light',
    benefit2Desc: 'Slim frames allow for larger glass areas and more natural light',
    benefit3: 'Color Options',
    benefit3Desc: 'Available in various finishes including anodized and powder-coated',
    benefit4: 'Recyclable',
    benefit4Desc: 'Environmentally friendly and fully recyclable material',
    benefit5: 'Fire Resistant',
    benefit5Desc: 'Non-combustible material provides added safety',
    benefit6: 'Low Maintenance',
    benefit6Desc: 'Easy to clean and requires minimal upkeep',
    ctaTitle: 'Ready for Modern Aluminum Windows?',
    ctaDesc: 'Contact us today for a free consultation. Our team will help you select the perfect aluminum windows for your contemporary home.'
  },
  slidingDoors: {
    badge: 'PREMIUM SLIDING DOORS',
    heroTitle: 'Milgard Sliding Doors',
    heroSubtitle: 'Expansive glass sliding doors that seamlessly connect indoor and outdoor living spaces',
    ctaButton: 'Get Free Quote',
    overviewTitle: 'Why Choose Sliding Doors',
    overviewDesc: 'Milgard sliding doors combine elegant design with smooth operation and energy efficiency. Featuring large glass panels and durable construction, our sliding doors create a seamless transition between your home and outdoor spaces.',
    feature1: 'Expansive Views',
    feature1Desc: 'Large glass panels maximize natural light and outdoor views',
    feature2: 'Smooth Operation',
    feature2Desc: 'Premium rollers ensure effortless sliding action',
    feature3: 'Secure Design',
    feature3Desc: 'Multi-point locking systems provide enhanced security',
    feature4: 'Lifetime Warranty',
    feature4Desc: 'Comprehensive warranty coverage on all components',
    stylesTitle: 'Available Door Styles',
    stylesSubtitle: 'Choose from various configurations to suit your space',
    style1: 'Two-Panel',
    style1Desc: 'Classic design with one fixed and one sliding panel',
    style2: 'Three-Panel',
    style2Desc: 'Wider opening with multiple panel configurations',
    style3: 'Four-Panel',
    style3Desc: 'Maximum opening width for expansive spaces',
    style4: 'Pocket Door',
    style4Desc: 'Panels slide into wall cavity for unobstructed opening',
    style5: 'Lift and Slide',
    style5Desc: 'Premium system with effortless operation for large panels',
    style6: 'Multi-Slide',
    style6Desc: 'Multiple panels stack for complete wall opening',
    galleryTitle: 'Sliding Doors Gallery',
    gallerySubtitle: 'Explore our collection of premium Milgard sliding doors in beautiful homes',
    benefitsTitle: 'Key Benefits',
    benefit1: 'Panoramic Views',
    benefit1Desc: 'Large glass areas provide unobstructed outdoor views',
    benefit2: 'Space Saving',
    benefit2Desc: 'No swing radius required, ideal for tight spaces',
    benefit3: 'Energy Efficient',
    benefit3Desc: 'Advanced weatherstripping and Low-E glass reduce energy costs',
    benefit4: 'Natural Light',
    benefit4Desc: 'Maximize daylight to brighten your living spaces',
    benefit5: 'Enhanced Security',
    benefit5Desc: 'Multi-point locks and reinforced frames ensure safety',
    benefit6: 'Easy Maintenance',
    benefit6Desc: 'Simple to clean and maintain for lasting performance',
    ctaTitle: 'Ready to Transform Your Space?',
    ctaDesc: 'Contact us today for a free consultation. Our experts will help you choose the perfect sliding doors to connect your indoor and outdoor living areas.'
  },
  frenchDoors: {
    hero: {
      title: 'French Doors',
      subtitle: 'Elegant Design Meets Timeless Beauty',
      cta: 'Get a Free Quote'
    },
    overview: {
      title: 'Classic Elegance for Your Home',
      description: 'French doors bring timeless sophistication and natural light to any space. With their distinctive glass panels and elegant design, they create a seamless connection between indoor and outdoor living while adding architectural beauty to your home.',
      feature1: {
        title: 'Classic Design',
        description: 'Timeless style with multiple glass panels that never goes out of fashion'
      },
      feature2: {
        title: 'Natural Light',
        description: 'Maximize sunlight with expansive glass panels throughout the door'
      },
      feature3: {
        title: 'Versatile Options',
        description: 'Available in various materials, finishes, and configurations'
      },
      feature4: {
        title: 'Indoor & Outdoor',
        description: 'Perfect for patios, balconies, or interior room dividers'
      }
    },
    styles: {
      title: 'French Door Styles',
      subtitle: 'Choose from our collection of elegant French door configurations',
      style1: {
        title: 'Traditional French Doors',
        description: 'Classic hinged double doors with divided glass panels and decorative grilles for timeless elegance'
      },
      style2: {
        title: 'Contemporary French Doors',
        description: 'Modern design with clean lines, minimal frames, and large unobstructed glass panels'
      },
      style3: {
        title: 'French Doors with Sidelights',
        description: 'Enhanced entry with matching glass panels on one or both sides for extra light and symmetry'
      },
      style4: {
        title: 'Sliding French Doors',
        description: 'Space-saving design that combines French door aesthetics with sliding functionality'
      },
      style5: {
        title: 'French Doors with Transom',
        description: 'Elevated design featuring decorative glass panels above the doors for added height and light'
      },
      style6: {
        title: 'Interior French Doors',
        description: 'Perfect room dividers that maintain openness while defining separate living spaces'
      }
    },
    gallery: {
      title: 'French Door Gallery',
      subtitle: 'Explore our collection of beautiful French door installations'
    },
    benefits: {
      title: 'Why Choose French Doors',
      subtitle: 'Discover the advantages of installing French doors in your home',
      benefit1: {
        title: 'Architectural Beauty',
        description: 'Add timeless elegance and sophisticated style to any room or entrance'
      },
      benefit2: {
        title: 'Abundant Natural Light',
        description: 'Expansive glass panels flood your space with sunlight and create an airy atmosphere'
      },
      benefit3: {
        title: 'Indoor-Outdoor Connection',
        description: 'Seamlessly blend interior and exterior spaces for enhanced living experience'
      },
      benefit4: {
        title: 'Increased Home Value',
        description: 'French doors are a desirable feature that can boost your property value'
      },
      benefit5: {
        title: 'Flexible Configurations',
        description: 'Available in various sizes, materials, and opening styles to suit your needs'
      },
      benefit6: {
        title: 'Energy Efficient Options',
        description: 'Modern French doors with quality glass and seals help maintain comfortable temperatures'
      }
    },
    cta: {
      title: 'Ready to Add French Doors?',
      description: 'Contact us today for a free consultation and quote on your French door installation',
      button: 'Contact Us Today'
    }
  },
  showerDoors: {
    hero: {
      title: 'JS Glass Shower Doors',
      subtitle: 'Transform Your Bathroom with Custom Glass Solutions',
      cta: 'Get a Free Quote'
    },
    overview: {
      title: 'Premium Shower Door Solutions',
      description: 'Elevate your bathroom with our custom shower doors. From frameless glass to semi-frameless designs, we offer high-quality solutions that combine functionality with stunning aesthetics to create your perfect shower enclosure.',
      feature1: {
        title: 'Premium Glass',
        description: 'High-quality tempered safety glass for durability and clarity'
      },
      feature2: {
        title: 'Custom Fit',
        description: 'Precisely measured and tailored to your bathroom specifications'
      },
      feature3: {
        title: 'Quality Hardware',
        description: 'Durable hinges, handles, and seals in various finishes'
      },
      feature4: {
        title: 'Easy Maintenance',
        description: 'Smooth surfaces and protective coatings for effortless cleaning'
      }
    },
    styles: {
      title: 'Shower Door Styles',
      subtitle: 'Explore our range of shower door designs to match your bathroom',
      style1: {
        title: 'Frameless Glass Doors',
        description: 'Sleek, modern design with minimal hardware for a clean, open look and maximum light'
      },
      style2: {
        title: 'Semi-Frameless Doors',
        description: 'Balanced design with subtle framing that offers stability while maintaining a contemporary aesthetic'
      },
      style3: {
        title: 'Sliding Shower Doors',
        description: 'Space-efficient solution with smooth gliding panels, ideal for smaller bathrooms'
      },
      style4: {
        title: 'Pivot Shower Doors',
        description: 'Classic swinging design with elegant hinges, perfect for wider shower openings'
      },
      style5: {
        title: 'Neo-Angle Doors',
        description: 'Corner installation design that maximizes space efficiency in compact bathrooms'
      },
      style6: {
        title: 'Walk-In Shower Panels',
        description: 'Open concept design with fixed glass panels for a luxurious, spa-like experience'
      }
    },
    gallery: {
      title: 'Shower Door Gallery',
      subtitle: 'View our collection of custom shower door installations'
    },
    benefits: {
      title: 'Why Choose Our Shower Doors',
      subtitle: 'Experience the advantages of quality shower door installation',
      benefit1: {
        title: 'Modern Aesthetics',
        description: 'Transform your bathroom with sleek, contemporary glass that enhances any design style'
      },
      benefit2: {
        title: 'Safety First',
        description: 'All glass is tempered for maximum safety and meets industry standards'
      },
      benefit3: {
        title: 'Water Containment',
        description: 'Precision seals and proper installation prevent leaks and water damage'
      },
      benefit4: {
        title: 'Durability',
        description: 'Quality materials and hardware ensure long-lasting performance and reliability'
      },
      benefit5: {
        title: 'Custom Solutions',
        description: 'Every shower door is measured and fabricated specifically for your space'
      },
      benefit6: {
        title: 'Professional Installation',
        description: 'Expert installation ensures perfect fit, function, and finish'
      }
    },
    cta: {
      title: 'Ready for a Bathroom Upgrade?',
      description: 'Contact us today for a free consultation and quote on your custom shower door',
      button: 'Contact Us Today'
    }
  },
  woodWindows: {
    hero: {
      title: 'JELD-WEN Wood Windows & Doors',
      subtitle: 'Classic Beauty with Natural Warmth and Superior Performance',
      cta: 'Get a Free Quote'
    },
    overview: {
      title: 'Timeless Elegance of Wood',
      description: 'JELD-WEN wood windows and doors bring natural beauty and warmth to your home. Crafted from premium materials with exceptional attention to detail, our wood products offer superior insulation, authentic character, and lasting value.',
      feature1: {
        title: 'Natural Beauty',
        description: 'Authentic wood grain texture adds warmth and character to any space'
      },
      feature2: {
        title: 'Superior Insulation',
        description: 'Natural wood provides excellent thermal performance and energy efficiency'
      },
      feature3: {
        title: 'Customizable Finish',
        description: 'Stain or paint to match your unique style and décor preferences'
      },
      feature4: {
        title: 'Premium Craftsmanship',
        description: 'JELD-WEN quality construction ensures durability and long-lasting performance'
      }
    },
    styles: {
      title: 'Wood Window & Door Styles',
      subtitle: 'Explore our collection of classic wood products',
      style1: {
        title: 'Double Hung Wood Windows',
        description: 'Traditional style with both sashes operable, featuring authentic divided lites and classic proportions'
      },
      style2: {
        title: 'Casement Wood Windows',
        description: 'Side-hinged design with elegant hardware, providing excellent ventilation and unobstructed views'
      },
      style3: {
        title: 'Wood Entry Doors',
        description: 'Grand entrance doors with rich wood grain, decorative glass options, and impressive curb appeal'
      },
      style4: {
        title: 'Wood French Doors',
        description: 'Classic elegance with multiple glass panels, perfect for patios and interior spaces'
      },
      style5: {
        title: 'Bay & Bow Wood Windows',
        description: 'Architectural beauty that extends living space and floods rooms with natural light'
      },
      style6: {
        title: 'Custom Wood Shapes',
        description: 'Specialty shapes including arches, circles, and geometric designs for unique architectural statements'
      }
    },
    gallery: {
      title: 'Wood Windows & Doors Gallery',
      subtitle: 'Discover the timeless beauty of JELD-WEN wood products'
    },
    benefits: {
      title: 'Why Choose Wood Windows & Doors',
      subtitle: 'Experience the advantages of authentic wood products',
      benefit1: {
        title: 'Natural Insulation',
        description: 'Wood naturally insulates better than vinyl or aluminum, reducing energy costs'
      },
      benefit2: {
        title: 'Authentic Character',
        description: 'Real wood grain patterns create warmth and elegance that cannot be replicated'
      },
      benefit3: {
        title: 'Design Versatility',
        description: 'Stain, paint, or finish to perfectly match your home\'s style and color scheme'
      },
      benefit4: {
        title: 'Sound Dampening',
        description: 'Superior acoustic properties reduce outside noise for a quieter home'
      },
      benefit5: {
        title: 'Increased Home Value',
        description: 'Premium wood products enhance property value and appeal to discerning buyers'
      },
      benefit6: {
        title: 'Sustainable Choice',
        description: 'Responsibly sourced wood is a renewable, eco-friendly building material'
      }
    },
    cta: {
      title: 'Ready for Classic Wood Beauty?',
      description: 'Contact us today for a free consultation on JELD-WEN wood windows and doors',
      button: 'Contact Us Today'
    }
  },
  fiberglassDoors: {
    hero: {
      title: 'JELD-WEN Fiberglass Entry Doors',
      subtitle: 'Stunning beauty with unmatched durability and performance',
      cta: 'Get Free Quote'
    },
    overview: {
      title: 'The Perfect Entry Door Solution',
      description: 'JELD-WEN fiberglass entry doors combine the authentic look of wood with superior durability and low maintenance. Engineered to withstand harsh weather while maintaining their beauty, these doors offer exceptional energy efficiency and lasting value.',
      feature1: {
        title: 'Authentic Wood Look',
        description: 'Realistic wood grain texture that looks and feels like real wood without the maintenance'
      },
      feature2: {
        title: 'Weather Resistant',
        description: 'Won\'t warp, crack, or rot even in extreme temperatures and humidity'
      },
      feature3: {
        title: 'Energy Efficient',
        description: 'Superior insulation reduces energy costs and improves home comfort'
      },
      feature4: {
        title: 'Low Maintenance',
        description: 'Durable finish resists fading and requires minimal upkeep over the years'
      }
    },
    styles: {
      title: 'Fiberglass Door Styles',
      subtitle: 'Choose from our extensive collection of entry door designs',
      style1: {
        title: 'Traditional Panel Doors',
        description: 'Classic raised panel designs with authentic wood grain texture for timeless curb appeal'
      },
      style2: {
        title: 'Craftsman Style Doors',
        description: 'Arts and Crafts inspired designs with clean lines and decorative glass options'
      },
      style3: {
        title: 'Modern Contemporary Doors',
        description: 'Sleek minimalist designs with smooth surfaces and geometric glass patterns'
      },
      style4: {
        title: 'Rustic Doors',
        description: 'Textured finishes that replicate aged wood for farmhouse and rustic home styles'
      },
      style5: {
        title: 'Glass Panel Entry Doors',
        description: 'Elegant designs with decorative glass inserts for enhanced natural light'
      },
      style6: {
        title: 'Double Entry Doors',
        description: 'Grand entrance systems with matching door pairs for impressive entryways'
      }
    },
    gallery: {
      title: 'Fiberglass Entry Door Gallery',
      subtitle: 'Explore our beautiful collection of JELD-WEN fiberglass doors'
    },
    benefits: {
      title: 'Why Choose Fiberglass Entry Doors',
      subtitle: 'Discover the advantages of premium fiberglass construction',
      benefit1: {
        title: 'Superior Durability',
        description: 'Resists dents, scratches, and damage better than wood or steel doors'
      },
      benefit2: {
        title: 'All-Weather Performance',
        description: 'Maintains integrity and appearance in extreme heat, cold, and humidity'
      },
      benefit3: {
        title: 'Enhanced Security',
        description: 'Solid construction with multi-point locking systems for peace of mind'
      },
      benefit4: {
        title: 'Energy Savings',
        description: 'Excellent insulation reduces heating and cooling costs year-round'
      },
      benefit5: {
        title: 'Authentic Appearance',
        description: 'Realistic wood grain texture can be stained to match any wood species'
      },
      benefit6: {
        title: 'Long-Term Value',
        description: 'Minimal maintenance and lasting beauty provide excellent return on investment'
      }
    },
    cta: {
      title: 'Ready to Upgrade Your Entry?',
      description: 'Contact us today for a free consultation on JELD-WEN fiberglass entry doors',
      button: 'Contact Us Now'
    }
  },
  commercialGlass: {
    badge: 'Commercial Glass Solutions',
    heroTitle: 'Commercial Glass Systems',
    heroSubtitle: 'Professional glass solutions for modern commercial spaces and buildings',
    ctaButton: 'Get Free Quote',
    overviewTitle: 'Why Choose Commercial Glass',
    overviewDesc: 'Our commercial glass solutions provide modern aesthetics, energy efficiency, and durability for businesses. From storefronts to office partitions, we deliver professional installations that enhance your commercial space while meeting building codes and safety standards.',
    feature1: 'Modern Design',
    feature1Desc: 'Sleek glass systems that create professional, contemporary spaces',
    feature2: 'Safety Compliant',
    feature2Desc: 'All installations meet commercial building codes and safety requirements',
    feature3: 'Energy Efficient',
    feature3Desc: 'Advanced glazing technology reduces energy costs and improves comfort',
    feature4: 'Expert Installation',
    feature4Desc: 'Professional installation by experienced commercial glass specialists',
    stylesTitle: 'Commercial Glass Applications',
    stylesSubtitle: 'Comprehensive glass solutions for every commercial need',
    style1: 'Curtain Wall Systems',
    style1Desc: 'Floor-to-ceiling glass facades for modern commercial buildings',
    style2: 'Storefront Glass',
    style2Desc: 'Attractive retail entrances with large display windows and doors',
    style3: 'Glass Partitions',
    style3Desc: 'Interior glass walls for offices, creating open yet defined spaces',
    style4: 'Commercial Doors',
    style4Desc: 'Automatic and manual glass door systems for business entrances',
    style5: 'Glass Railings',
    style5Desc: 'Frameless glass railing systems for balconies and stairs',
    style6: 'Glass Canopies',
    style6Desc: 'Structural glass canopies and awnings for building entrances',
    galleryTitle: 'Commercial Glass Gallery',
    gallerySubtitle: 'View our professional commercial glass installations',
    benefitsTitle: 'Key Benefits',
    benefit1: 'Natural Light',
    benefit1Desc: 'Maximize daylight to create bright, productive work environments',
    benefit2: 'Professional Appearance',
    benefit2Desc: 'Modern glass systems enhance your business image and brand',
    benefit3: 'Energy Performance',
    benefit3Desc: 'High-performance glazing reduces HVAC costs and improves efficiency',
    benefit4: 'Durability',
    benefit4Desc: 'Commercial-grade materials built to withstand heavy use',
    benefit5: 'Cost Effective',
    benefit5Desc: 'Long-term value with minimal maintenance requirements',
    benefit6: 'Expert Support',
    benefit6Desc: 'Professional consultation, installation, and ongoing service',
    ctaTitle: 'Ready for Your Commercial Glass Project?',
    ctaDesc: 'Contact us today for a free consultation and quote on commercial glass solutions for your business.'
  }
};